/** student/skills — KEYS. */
export const studentSkillsKeys = {
  all: () => ['student', 'skills'] as const,
};
